/* PACKAGES */
import React from 'react';

/* UTILS */
import { getMediaChild } from '../../utils/slider';

/* STYLES */
import s from './Slider.module.scss';

const SliderThumbs = ({ infinite, childrenCopy, index, goToSlide }) => {
	const handleNavClick = (e) => {
		e.preventDefault();
		const toIndex = e.currentTarget.value;
		goToSlide((parseInt(toIndex, 10) + infinite), e);
	};

	const createThumbs = () => {
		const mediaChildren = getMediaChild(childrenCopy);
		return React.Children.map(mediaChildren, (child) => {
			const childProps = {};
			childProps.src = child.props.src.replace(/-\d+x(\.\w+)$/, '-400x$1');
			return React.cloneElement(child, childProps);
		});
	};

	const thumbChildren = createThumbs();

	if (thumbChildren.length < 2) return null;

	return (
		<div className={[s.slider_thumbs, 'u_slideThumbs'].join(' ')}>
			<div className={s.slider_thumbs_inner}>
				{
					thumbChildren.map((child, i) => <button type="button" key={`${child.key}Thumb`} className={[s.slider_thumbs_inner_thumb, (child.type === 'video' ? s.slider_thumbs_inner_thumb__film : null), (i === (index - infinite) ? s.slider_thumbs_inner_thumb__selected : null)].join(' ')} value={i} onClick={handleNavClick}>{ child }</button>)
				}
			</div>
		</div>
	);
};

export default SliderThumbs;
